export default "__VITE_ASSET__BkYicjSE__"